import { useState, useCallback, useEffect, useRef } from 'react';
import { favoritesService } from '../lib/favorites/favoritesService';
import type { FavoriteItem } from '../types/favorites';
import { logger } from '../lib/logger';

export const useFavorites = () => {
  const [favorites, setFavorites] = useState<FavoriteItem[]>([]);
  const isInitialized = useRef(false);

  // Charger les favoris une seule fois au montage
  useEffect(() => {
    if (!isInitialized.current) {
      const loadedFavorites = favoritesService.getFavorites();
      setFavorites(loadedFavorites);
      isInitialized.current = true;

      logger.debug('Favorites loaded', {
        category: 'Favorites',
        data: { count: loadedFavorites.length }
      });
    }
  }, []);

  // Supprimer un favori
  const removeFavorite = useCallback((itemId: string) => {
    favoritesService.removeFavorite(itemId);
    setFavorites(favoritesService.getFavorites());
    
    logger.debug('Favorite removed', {
      category: 'Favorites',
      data: { itemId }
    });
  }, []);

  return {
    favorites,
    removeFavorite
  };
};